import MessageConstants from "Components/MessageToaster/Constants";
import * as HttpStatus from "http-status-codes";
import { injectable } from "inversify";
import { Dispatch } from "react";
import { ActionTypes, ILogoutAction } from "Store/Authentication/AuthenticationActionTypes";
import { ActionTypes as MessageActionTypes, IShowMessageToasterAction } from "Store/MessageToaster/MessageToasterActionTypes";

export interface IErrorHandlingAction {
    handleError(error: any, dispatch: Dispatch<any>, customError?: ICustomError): any;
}

export interface ICustomError {
    error: any;
    statusCode: number;
    message: string;
}

@injectable()
export class ErrorHandlingAction implements IErrorHandlingAction {
    public handleError(error: any, dispatch: Dispatch<any>, customError: ICustomError) {
        if (customError) {
            if (customError.error.response && customError.error.response.statusCode) {
                switch (customError.error.response.statusCode) {
                    case customError.statusCode:
                        this.handleCustomError(dispatch, customError.message);
                        break;
                }
            }
        }

        if (error.response && error.response.statusCode) {
            switch (error.response.statusCode) {
                case HttpStatus.UNAUTHORIZED:
                    this.handleUnauthorized(dispatch);
                    break;
                case HttpStatus.INTERNAL_SERVER_ERROR:
                    this.handleUnknownError(dispatch);
                    break;
            }
        }
        else {
            this.handleUnknownError(dispatch);
        }
    }

    private handleUnauthorized = (dispatch: Dispatch<ILogoutAction | IShowMessageToasterAction>) => {
        dispatch({
            type: ActionTypes.LOGOUT
        });

        dispatch({
            type: MessageActionTypes.SHOW_MESSAGE,
            data: { type: MessageConstants.MESSAGE_TYPE_DANGER, text: "Unauthorized." }
        });
    }

    private handleUnknownError = (dispatch: Dispatch<IShowMessageToasterAction>) => {
        dispatch({
            type: MessageActionTypes.SHOW_MESSAGE,
            data: { type: MessageConstants.MESSAGE_TYPE_DANGER, text: "Unknown error occurred." }
        });
    }

    private handleCustomError = (dispatch: Dispatch<IShowMessageToasterAction>, message: string) => {
        dispatch({
            type: MessageActionTypes.SHOW_MESSAGE,
            data: { type: MessageConstants.MESSAGE_TYPE_DANGER, text: message }
        });
    }
}


// WEBPACK FOOTER //
// ./src/Store/ErrorHandling/ErrorHandlingAction.tsx